// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ground-deicing-methods.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ground-deicing-methods/ground-deicing-methods.js';

mount([g0]);
